// extracted by mini-css-extract-plugin
export var cardIcon = "_75-5";
export var checkboxCard = "_75-0";
export var checkboxCardSelected = "_75-4";
export var disabled = "_75-2";
export var interactive = "_75-1";
export var outerBorder = "_75-3";
export var spacerMedium = "_75-8";
export var spacerSmall = "_75-7";
export var spacerXsmall = "_75-6";